<div *ngFor="let group of contractStatesByGroupId$ | async">
  <div class="card h-100">
    <div class="card-body">
      <app-contract-state-tab-entry [contractStatesForGroupId]="group"></app-contract-state-tab-entry>
    </div>
  </div>
  <br />
</div>
